import { useState } from "react";

export default function TablePagination({
  totalEntries,
  currentPage: controlledPage,
  onPageChange,
  pageSize: controlledPageSize,
  onPageSizeChange,
}) {
  const [internalPageSize, setInternalPageSize] = useState(10);
  const [internalPage, setInternalPage] = useState(1);

  const pageSize = controlledPageSize ?? internalPageSize;
  const currentPage = controlledPage ?? internalPage;

  const totalPages =
    pageSize > 0 ? Math.ceil((totalEntries || 0) / pageSize) : 1;

  const start = totalEntries
    ? (currentPage - 1) * pageSize + 1
    : 0;

  const end = totalEntries
    ? Math.min(currentPage * pageSize, totalEntries)
    : 0;

  const pageNumbers =
    totalPages > 0
      ? [...Array(totalPages).keys()].map((i) => i + 1)
      : [];

  const changePage = (page) => {
    if (onPageChange) {
      onPageChange(page);
    } else {
      setInternalPage(page);
    }
  };

  const changePageSize = (size) => {
    if (onPageSizeChange) {
      onPageSizeChange(size);
    } else {
      setInternalPageSize(size);
      setInternalPage(1);
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-1 py-1 px-3 bg-gray-100 rounded-md text-sm">
      {/* Page size selector */}
      <div className="flex items-center gap-1">
        <span>Show</span>
        <select
          className="border border-gray-300 rounded px-2 py-1 bg-white"
          value={pageSize}
          onChange={(e) => changePageSize(Number(e.target.value))}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={30}>30</option>
        </select>
        <span>entries</span>
      </div>

      {/* Showing X to Y of Z */}
      <div className="text-gray-600">
        Showing{" "}
        <span className="font-medium">{start}</span> to{" "}
        <span className="font-medium">{end}</span> of{" "}
        <span className="font-medium">{totalEntries || 0}</span> entries
      </div>

      {/* Pagination buttons */}
      <div className="flex items-center gap-2">
        {/* Previous */}
        <button
          className="px-3 py-1 rounded border bg-white hover:bg-gray-50 disabled:opacity-50"
          disabled={currentPage <= 1}
          onClick={() => changePage(currentPage - 1)}
        >
          Previous
        </button>

        {/* Page numbers */}
        {pageNumbers.map((num) => (
          <button
            key={num}
            className={`px-3 py-1 rounded border ${
              currentPage === num
                ? "bg-black text-white"
                : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => changePage(num)}
          >
            {num}
          </button>
        ))}

        {/* Next */}
        <button
          className="px-3 py-1 rounded border bg-white hover:bg-gray-50 disabled:opacity-50"
          disabled={currentPage >= totalPages}
          onClick={() => changePage(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
